import React, { useEffect, useRef } from "react";
import { BrowserRouter, Routes, Route, useLocation, useNavigate } from "react-router-dom";
import { Toaster } from "sonner";
import { SiteProvider, useSite } from "@/lib/SiteContext";
import { useLenis } from "@/lib/useLenis";
import { exchangeSession } from "@/lib/api";
import Home from "@/pages/Home";
import Login from "@/pages/Login";
import Admin from "@/pages/Admin";
import NotFound from "@/pages/NotFound";
import "@/App.css";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
function AuthCallback() {
    const navigate = useNavigate();
    const { refreshUser } = useSite();
    const processed = useRef(false);

    useEffect(() => {
        if (processed.current) return;
        processed.current = true;

        const hash = window.location.hash || "";
        const match = hash.match(/session_id=([^&]+)/);
        if (!match) {
            navigate("/", { replace: true });
            return;
        }
        const session_id = decodeURIComponent(match[1]);

        (async () => {
            try {
                await exchangeSession(session_id);
                await refreshUser();
                // Clean the URL and go to admin
                window.history.replaceState(null, "", "/admin");
                navigate("/admin", { replace: true });
            } catch (e) {
                console.error("auth exchange failed", e);
                navigate("/login?error=1", { replace: true });
            }
        })();
    }, [navigate, refreshUser]);

    return (
        <div className="min-h-screen bg-ink-900 flex items-center justify-center text-white">
            <div className="font-mono-label text-white/70">Signing you in…</div>
        </div>
    );
}

function AppRouter() {
    const location = useLocation();
    useLenis();

    // Detect OAuth callback synchronously during render
    if (location.hash?.includes("session_id=")) {
        return <AuthCallback />;
    }
    return (
        <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/login" element={<Login />} />
            <Route path="/admin" element={<Admin />} />
            <Route path="*" element={<NotFound />} />
        </Routes>
    );
}

export default function App() {
    return (
        <div className="App bg-ink-900 min-h-screen">
            <SiteProvider>
                <BrowserRouter>
                    <AppRouter />
                    <Toaster
                        theme="dark"
                        position="bottom-right"
                        toastOptions={{
                            style: { background: "#121212", border: "1px solid rgba(255,255,255,0.1)", color: "#fff" },
                        }}
                    />
                </BrowserRouter>
            </SiteProvider>
        </div>
    );
}
